// C.1 — пакет реализаций для common-юнитов Глобала.
// 7 юнитов: Бастион G-12, Дрон GS-1, Гранатёр G-Sec, Боец G-Sec,
//           Медик «Янтарь», Сапёр Оникс, Стрелок Кобра.
//
// Бастион/Дрон/Боец G-Sec/Стрелок Кобра — vanilla юниты (только keyword'ы
// из xlsx). Им не нужны ability-функции.
//
// Гранатёр G-Sec — Order: 1 урон всем юнитам на вражеской линии напротив.
// Медик «Янтарь» — Trigger turn_end: 1 хил союзнику с самым низким hp.
// Сапёр Оникс — Order: enemy_choose → armor_break 1 max armor.

import { registerImplementedAbility } from '../../warn-unimplemented.js';
import { applyDamage } from '../../../combat.js';
import { healUnit } from '../../livlife/heal.js';
import { resolveTarget } from '../../../effects/targets.js';
import { getHealTarget } from '../../../heal-priority.js';
import { registerOnEndOfTurnExtraHandler } from '../../deus/hooks.js';
import { registerC1Order } from './order-registry.js';

// === Гранатёр G-Sec ===
// Внутренний id оставлен прежним (global_granater_kantao) для совместимости
// с уже сохранёнными колодами/инвентарём в БД — id игроку не виден.
const KANTAO_ID = 'global_granater_kantao';

export function kantaoOrder(state, sourceCard) {
  // Цель: enemy_aoe_line — все юниты на вражеской линии напротив этой карты.
  const targets = resolveTarget(state, sourceCard, 'enemy_aoe_line');
  for (const t of targets) {
    applyDamage(t, 1, {
      state,
      source: sourceCard
    });
  }
  if (state.log) state.log.add(`💣 ${sourceCard.name_ru}: 1 урон ${targets.length} вражеским юнитам на линии`);
  return { ok: true, hit: targets.length };
}
registerImplementedAbility(KANTAO_ID, 'order');
registerC1Order(KANTAO_ID, kantaoOrder);

// === Сапёр Оникс ===
const ONIX_ID = 'global_saper_onix';

export function onixOrder(state, sourceCard, opts = {}) {
  // Order: target=enemy_choose → armor_break:1. opts.target — выбранный.
  const target = opts.target;
  if (!target) return { ok: false, reason: 'no_target' };
  if (target.type !== 'unit') return { ok: false, reason: 'not_unit' };
  if (target.ownerId === sourceCard.ownerId) return { ok: false, reason: 'not_enemy' };
  // armor_break:1 — снимает 1 max_armor (с синхронным -1 current).
  if (target.current) {
    target.current.armor = Math.max(0, (target.current.armor || 0) - 1);
  }
  if (typeof target.persistentMaxArmor === 'number') {
    target.persistentMaxArmor = Math.max(0, target.persistentMaxArmor - 1);
  }
  if (typeof target.persistentArmor === 'number') {
    target.persistentArmor = Math.max(0, target.persistentArmor - 1);
  }
  if (state.log) state.log.add(`💥 ${sourceCard.name_ru}: ${target.name_ru} -1 max armor`);
  return { ok: true };
}
registerImplementedAbility(ONIX_ID, 'order');
registerC1Order(ONIX_ID, onixOrder);

// === Медик «Янтарь» ===
const YANTAR_ID = 'global_medik_yantar';

function yantarOnEot(state, playerIdx) {
  const p = state.players?.[playerIdx];
  if (!p?.field) return;
  for (const row of p.field) {
    if (!row) continue;
    for (const u of row) {
      if (!u || u.id !== YANTAR_ID) continue;
      if (u.current?.silenced) continue;
      if (!u.isAlive || !u.isAlive()) continue;
      // По приоритету лечения (healPriority). Дефолт/бот — lowest_hp.
      const t = getHealTarget(state, u);
      if (t) {
        healUnit(state, t, 1, u);
      }
    }
  }
}

registerOnEndOfTurnExtraHandler((state) => {
  for (let i = 0; i < state.players.length; i++) yantarOnEot(state, i);
});
registerImplementedAbility(YANTAR_ID, 'trigger');
